import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, DeptModulesGrid } from '../../Components/Common/DashboardKit';

/**
 * Shukla module landing page.
 *
 * Owner (2026-10-05/06): the department pages show MODULES, one card per module, the
 * same cards as the Workflows catalog (DeptLandingSections); a card shows only when the
 * person may open it, so India accounts see only their own modules. The Reports & KPI
 * card opens the KPI hub on the Shukla tab. No "coming soon" note. Gated by dept.shukla.
 */
const MODULES = ["display", "di", "app-mafia", "dms", "cr", "tasks", "epo", "kpi"];

const Shukla = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-building-2-line"
                        eyebrow="Shukla Medical"
                        title="Shukla"
                        subtitle="Tools and reports for the Shukla Medical line"
                        tone="default"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Shukla" },
                        ]}
                    />

                    <DeptModulesGrid ids={MODULES} dept="shukla" title="Shukla modules" icon="ri-building-2-line" />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Shukla;
